import React, { useState } from "react";
import { GlobalNotificationSettings, AccountNotificationSettings } from "../../components/compliance";

const NotificationSettings = () => {
  const [activeTab, setActiveTab] = useState("global");

  return (
    <div className="p-6 space-y-6">
      {/* Page Header */}
      <div>
        <h1 className="text-2xl font-bold text-slate-800">
          Compliance Notification Settings
        </h1>
        <p className="text-slate-600 mt-1">
          Configure email notifications for compliance document status changes
        </p>
      </div>

      {/* Tabs */}
      <div className="border-b border-slate-200">
        <nav className="flex gap-4">
          <button
            onClick={() => setActiveTab("global")}
            className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
              activeTab === "global"
                ? "border-indigo-600 text-indigo-600"
                : "border-transparent text-slate-600 hover:text-slate-800 hover:border-slate-300"
            }`}
          >
            Global Settings
          </button>
          <button
            onClick={() => setActiveTab("account")}
            className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
              activeTab === "account"
                ? "border-blue-600 text-blue-600"
                : "border-transparent text-slate-600 hover:text-slate-800 hover:border-slate-300"
            }`}
          >
            Account Settings
          </button>
        </nav>
      </div>

      {/* Tab Content */}
      <div>
        {activeTab === "global" && <GlobalNotificationSettings />}
        {activeTab === "account" && <AccountNotificationSettings />}
      </div>

      {/* Info Box */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <h4 className="font-semibold text-blue-900 mb-2">How it works:</h4>
        <ul className="text-sm text-blue-800 space-y-1">
          <li>
            • <strong>Global Settings:</strong> Default notification preferences for all accounts
          </li>
          <li>
            • <strong>Account Settings:</strong> Override global settings for specific accounts
          </li>
          <li>
            • <strong>Priority:</strong> Account-level settings take precedence over global settings
          </li>
          <li>
            • <strong>Status Changes:</strong> Configure which status transitions trigger email notifications
          </li>
          <li>
            • <strong>Categories:</strong> Set different preferences for GST, TDS, Income Tax, Legal, and Internal Accounting
          </li>
        </ul>
      </div>
    </div>
  );
};

export default NotificationSettings;
